import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Button from '@mui/material/Button'
import makeStyles from '@mui/styles/makeStyles'
import ContentPage from '../Common/ContentPage'
import { downloadSecureDocument } from '../../api/download'
import { displaySnackbar } from '../../actions/main'

import styles from './styles/legalStyles'
import { useAppDispatch } from '../../store'

const useStyles = makeStyles(styles)

const Legal = () => {
    const sourcePdf = 'TTD _ML_Requérant _Espace_TokTokDoc_v1.16_210309.pdf'
    const [pdfSrc, setPdfSrc] = useState(null)
    const dispatch = useAppDispatch()
    const classes = useStyles(styles)

    useEffect(() => {
        const getPdf = async () => {
            try {
                const res = await downloadSecureDocument(`${window._env_.REACT_APP_HDS_HOST}/legals/${sourcePdf}`)
                // @ts-expect-error TS(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
                setPdfSrc(URL.createObjectURL(res))
            } catch (error) {
                // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
                dispatch(displaySnackbar('error', error.message, undefined, `[Legal] erreur chargement des mentions legales error: ${error.message}`))
            }
        }

        getPdf()
    }, [dispatch])

    return (
        <ContentPage
            title="Mentions légales du service TokTokDoc"
            subtitle={
                "Les mentions légales de l'espace établissement TokTokDoc sont disponibles en lecture et en téléchargement ci-dessous :"
            }
        >
            <CardContent>
                <Grid container direction="column" alignItems="center" justifyContent="center" spacing={2}>
                    {pdfSrc && (
                        <Grid item xs={12} sm={6} md={2}>
                            <div className={classes.button}>
                                <Button variant="contained" color="primary">
                                    <a className={classes.buttonText} href={pdfSrc || '#'} download={sourcePdf}>
                                        Télécharger
                                    </a>
                                </Button>
                            </div>
                        </Grid>
                    )}
                </Grid>
            </CardContent>
            {pdfSrc && (
                <Grid container direction="column" alignItems="center" justifyContent="center">
                    <CardMedia
                        className={classes.media}
                        component="iframe"
                        image={`${window._env_.REACT_APP_HDS_HOST}/static/file/cgu/CGU_Effecteur.pdf`}
                    />
                </Grid>
            )}
        </ContentPage>
    )
}

export default Legal
